/* eslint-disable vue/no-reserved-component-names */
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

import 'view-ui-plus/dist/styles/viewuiplus.css';
import 'element-plus/dist/index.css';
import { AdminNames, ErrorNames } from '@/router/routerNames';
import ElementPlus from 'element-plus';
import 'vant/lib/index.css';
const app = createApp(App);

app.use(router);
app.use(ElementPlus);

// 按需引入
import {
  Button,
  Spin,
  Input,
  Select,
  Option,
  Poptip,
  Form,
  FormItem,
  Table,
  Page,
  Message,
  Modal,
  Dropdown,
  DropdownMenu,
  Switch,
  DatePicker,
  Tooltip,
  Upload,
  Progress,
  Tabs,
  TabPane,
  Sider,
  Layout,
  Checkbox,
  DropdownItem,
  Drawer,
  Row,
  Col,
  RadioGroup,
  Radio,
  Tree,
  CheckboxGroup,
  Cascader,
  Image,
  ImagePreview
} from 'view-ui-plus';
app.component('Button', Button);
app.component('Spin', Spin);
app.component('Input', Input);
app.component('Select', Select);
app.component('Option', Option);
app.component('Poptip', Poptip);
app.component('Form', Form);
app.component('FormItem', FormItem);
app.component('Table', Table);
app.component('Page', Page);
app.component('Page', Page);
app.component('Message', Message);
app.component('Modal', Modal);
app.component('Dropdown', Dropdown);
app.component('DropdownMenu', DropdownMenu);
app.component('DropdownItem', DropdownItem);
app.component('Switch', Switch);
app.component('DatePicker', DatePicker);
app.component('Tooltip', Tooltip);
app.component('Upload', Upload);
app.component('Progress', Progress);
app.component('Tabs', Tabs);
app.component('TabPane', TabPane);
app.component('Sider', Sider);
app.component('Layout', Layout);
app.component('Checkbox', Checkbox);
app.component('Drawer', Drawer);
app.component('Row', Row);
app.component('Col', Col);
app.component('RadioGroup', RadioGroup);
app.component('Radio', Radio);
app.component('Tree', Tree);
app.component('CheckboxGroup', CheckboxGroup);
app.component('Cascader', Cascader);
app.component('Image', Image);
app.component('ImagePreview', ImagePreview);

app.mount('#app');

app.config.globalProperties.AdminNames = AdminNames;
app.config.globalProperties.ErrorNames = ErrorNames;
